<template>
  <div>
    <!-- 搜索表单 -->
    <el-form :model="table.where" label-width="77px" class="ele-form-search" @keyup.enter.native="$refs.table.reload()" @submit.native.prevent>
      <el-row :gutter="15">
        <el-col :lg="3" :md="6" :sm="12">
          <el-form-item label="日期:">
            <el-date-picker
              v-model="date"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              @change="handleDateChange"
              clearable
              style="width: 270px"
            />
          </el-form-item>
        </el-col>
        <el-col :lg="3" :md="6" :sm="12">
          <el-form-item label="学部:">
            <el-select v-model="table.where.branchId" placeholder="请选择学部" style="width: 140px" @change="handleChange($event, 2)" clearable>
              <el-option v-for="item in branchList" :key="item.id" :label="item.name" :value="item.id" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="3" :md="6" :sm="12">
          <el-form-item label="年级:">
            <el-select v-model="table.where.gradeId" placeholder="请选择年级" style="width: 140px" @change="handleChange($event, 3)" clearable>
              <el-option v-for="item in gradeList" :key="item.id" :label="item.name" :value="item.id" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="3" :md="6" :sm="12">
          <el-form-item label="级部:">
            <el-select v-model="table.where.gradeItemId" placeholder="请选择级部" style="width: 140px" @change="handleChange($event, 4)" clearable>
              <el-option v-for="item in subGradeList" :key="item.id" :label="item.name" :value="item.id" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="3" :md="6" :sm="12">
          <el-form-item label="班级:">
            <el-select v-model="table.where.classId" placeholder="请选择班级" style="width: 140px" clearable @change="$forceUpdate()">
              <el-option v-for="item in classList" :key="item.id" :label="item.name" :value="item.id" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="4" :md="7" :sm="12">
          <el-form-item label="项目:">
            <el-select v-model="table.where.accessProjectId" placeholder="请选择项目" style="width: 140px" @change="$forceUpdate()" clearable>
              <el-option v-for="item in projectList" :key="item.id" :label="item.name" :value="item.id" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="4" :md="6" :sm="12">
          <div class="ele-form-actions">
            <el-button type="primary" @click="$refs.table.reload()" icon="el-icon-search" class="ele-btn-icon">查询</el-button>
            <el-button @click="(table.where = { type: 2 }) && $refs.table.reload()">重置</el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <!-- 操作按钮 -->
    <div class="ele-table-tool ele-table-tool-default">
      <el-button @click="add" type="primary" icon="el-icon-plus" class="ele-btn-icon" size="small">录入</el-button>
      <el-button @click="exportInfo" type="primary" icon="el-icon-download" class="ele-btn-icon" size="small">导出</el-button>
      <el-button @click="remove()" type="danger" icon="el-icon-delete" class="ele-btn-icon" size="small">批量删除</el-button>
    </div>
    <ele-data-table ref="table" :config="table" :choose.sync="choose" row-class-name="custom-row-class" highlight-current-row>
      <template>
        <el-table-column type="selection" width="45" align="center" />
        <el-table-column type="index" width="45" align="center" />
        <el-table-column prop="branchName" label="学部" show-overflow-tooltip align="center" />
        <el-table-column prop="gradeName" label="年级" show-overflow-tooltip align="center" />
        <el-table-column prop="gradeItemName" label="级部" show-overflow-tooltip align="center" />
        <el-table-column prop="className" label="班级" show-overflow-tooltip align="center" />
        <el-table-column prop="accessProjectName" label="项目" show-overflow-tooltip align="center" />
        <el-table-column prop="accessItemName" label="细则" show-overflow-tooltip align="center" />
        <el-table-column prop="itemType" label="属性" show-overflow-tooltip align="center" width="60">
          <template slot-scope="{ row }">
            {{ row.itemType == 1 ? '加分' : row.itemType == 2 ? '减分' : '' }}
          </template>
        </el-table-column>
        <el-table-column prop="studentScore" label="分值" show-overflow-tooltip align="center" width="50" />
        <el-table-column prop="createDay" label="录入日期" show-overflow-tooltip align="center" />
        <el-table-column prop="createUser" label="录入人" show-overflow-tooltip align="center" />
        <el-table-column prop="remark" label="备注" show-overflow-tooltip align="center" />
        <el-table-column label="操作" align="center" width="150">
          <template #default="{ row }">
            <el-link @click="editInfo(row)" icon="el-icon-edit" type="primary" :underline="false">编辑</el-link>
            <el-popconfirm title="确定要删除此数据？" @onConfirm="remove(row)" class="ele-action">
              <el-link slot="reference" icon="el-icon-delete" type="danger" :underline="false">删除</el-link>
            </el-popconfirm>
          </template>
        </el-table-column>
      </template>
    </ele-data-table>
    <el-dialog
      :title="editForm.id ? '编辑' : '录入'"
      :visible.sync="showEdit"
      width="60%"
      @closed="resetForm"
      :destroy-on-close="true"
      custom-class="ele-dialog-form"
      :lock-scroll="false"
    >
      <el-form :model="editForm" ref="editForm" :rules="editRules" label-width="85px">
        <el-row :gutter="15" style="margin-top: 20px">
          <el-col :sm="6">
            <el-form-item label="学部:" prop="branchId">
              <el-select v-model="editForm.branchId" placeholder="请选择学部" @change="diaHandleChange($event, 2)" clearable>
                <el-option v-for="item in dialogData.branchList" :key="item.id" :label="item.name" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :sm="6">
            <el-form-item label="年级:" prop="gradeId">
              <el-select v-model="editForm.gradeId" ref="grade" placeholder="请选择年级" @change="diaHandleChange($event, 3)" clearable>
                <el-option v-for="item in dialogData.gradeList" :key="item.id" :label="item.name" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :sm="6">
            <el-form-item label="级部:" prop="gradeItemId">
              <el-select v-model="editForm.gradeItemId" placeholder="请选择级部" @change="diaHandleChange($event, 4)" clearable>
                <el-option v-for="item in dialogData.subGradeList" :key="item.id" :label="item.name" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :sm="6">
            <el-form-item label="班级:" prop="classId">
              <el-select v-model="editForm.classId" placeholder="请选择班级" clearable @change="$forceUpdate()">
                <el-option v-for="item in dialogData.classList" :key="item.id" :label="item.name" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :sm="6">
            <el-form-item label="项目:" prop="accessProjectId">
              <el-select v-model="editForm.accessProjectId" @change="diaHandleChange($event, 7)" placeholder="请选择项目" class="ele-block" clearable>
                <el-option v-for="item in dialogData.projectList" :key="item.id" :label="item.name" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :sm="6">
            <el-form-item label="细则:" prop="accessItemId">
              <el-select v-model="editForm.accessItemId" placeholder="请选择细则" class="ele-block" @change="$forceUpdate()" clearable>
                <el-option v-for="item in dialogData.itemList" :key="item.id" :label="item.name" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :sm="6">
            <el-form-item label="录入日期:" prop="createDay">
              <el-date-picker
                v-model="editForm.createDay"
                type="date"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
                style="width: 183px"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :sm="6">
            <el-form-item label="录入人:" prop="createUser">
              <el-input v-model="editForm.createUser" />
            </el-form-item>
          </el-col>
          <el-col :sm="6">
            <el-form-item label="备注:">
              <el-input v-model="editForm.remark" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showEdit = false">取 消</el-button>
        <el-button type="primary" @click="saveRecord">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import { delAccessRecord, exportAccessRecord, saveAccessRecord, selectionList } from '@/config/fengyi/examine';

  export default {
    name: 'Class',
    data() {
      return {
        table: {
          // 表格配置
          url: '/fyAccess/getAccessRecordPage',
          method: 'GET',
          where: {
            type: 2,
          },
          parseData(res) {
            if (res.resCode == 200) res.code = 0;
            res.count = res.data.total;
            res.data = res.data.records;
            return res;
          },
        },
        editForm: {
          branchId: undefined,
          gradeId: undefined,
          gradeItemId: undefined,
          classId: undefined,
          accessProjectId: undefined,
          accessItemId: undefined,
          createDay: undefined,
          createUser: '',
          remark: '',
          type: 2,
        },
        editRules: {
          branchId: [{ required: true, message: '请选择学部', trigger: 'change' }],
          gradeId: [{ required: true, message: '请选择年级', trigger: 'change' }],
          gradeItemId: [{ required: true, message: '请选择级部', trigger: 'change' }],
          classId: [{ required: true, message: '请选择班级', trigger: 'change' }],
          createDay: [{ required: true, message: '请选择录入日期', trigger: 'change' }],
          accessProjectId: [{ required: true, message: '请选择项目', trigger: 'change' }],
          accessItemId: [{ required: true, message: '请选择项目细则', trigger: 'change' }],
          createUser: [{ required: true, message: '请输入录入人', trigger: 'blur' }],
        },
        choose: [],
        branchList: [],
        gradeList: [],
        subGradeList: [],
        classList: [],
        projectList: [],
        showEdit: false,
        dialogData: {
          branchList: [],
          gradeList: [],
          subGradeList: [],
          classList: [],
          projectList: [],
          itemList: [],
        },
        date: null,
      };
    },
    created() {
      this.searchListbyType(1);
      this.searchListbyType(6);
    },
    methods: {
      // 搜索下拉选
      searchListbyType(type, id) {
        let data = {
          type: type,
          id: id,
        };
        selectionList(data).then((res) => {
          if (res.data.resCode == 200) {
            if (type == 1) {
              //校部
              this.branchList = res.data.data;
            } else if (type == 2) {
              //年级
              this.gradeList = res.data.data;
            } else if (type == 3) {
              //级部
              this.subGradeList = res.data.data;
            } else if (type == 4) {
              //班级
              this.classList = res.data.data;
            } else if (type == 6) {
              //考核项目
              this.projectList = res.data.data;
            }
          }
        });
      },
      // 搜索下拉框值变化
      handleChange(value, type) {
        if (type == 2) {
          this.gradeList = [];
          this.subGradeList = [];
          this.classList = [];
          this.table.where.gradeId = null;
          this.table.where.gradeItemId = null;
          this.table.where.classId = null;
        } else if (type == 3) {
          this.subGradeList = [];
          this.classList = [];
          this.table.where.gradeItemId = null;
          this.table.where.classId = null;
        } else if (type == 4) {
          this.classList = [];
          this.table.where.classId = null;
        }
        this.searchListbyType(type, value);
      },
      handleDateChange(value) {
        this.table.where.startTime = value[0];
        this.table.where.endTime = value[1];
      },
      add() {
        this.showEdit = true;
        this.editForm.createUser = JSON.parse(sessionStorage.getItem('user')).teacherName;
        this.dialogData = {
          branchList: [],
          gradeList: [],
          subGradeList: [],
          classList: [],
          projectList: [],
          itemList: [],
        };
        this.dialogSelectList(1);
        this.dialogSelectList(6);
      },
      // 弹窗里面的下拉选接口
      dialogSelectList(type, id) {
        let data = {
          type: type,
          id: id,
        };
        selectionList(data).then((res) => {
          if (res.data.resCode == 200) {
            if (type == 1) {
              //校部
              this.dialogData.branchList = res.data.data;
            } else if (type == 2) {
              //年级
              this.dialogData.gradeList = res.data.data;
            } else if (type == 3) {
              //级部
              this.dialogData.subGradeList = res.data.data;
            } else if (type == 4) {
              //班级
              this.dialogData.classList = res.data.data;
            } else if (type == 6) {
              //考核项目
              this.dialogData.projectList = res.data.data;
            } else if (type == 7) {
              //考核项目细则
              this.dialogData.itemList = res.data.data;
            }
          }
        });
      },
      // 弹窗里下拉框变化
      diaHandleChange(value, type) {
        if (type == 2) {
          this.dialogData.gradeList = [];
          this.dialogData.subGradeList = [];
          this.dialogData.classList = [];
          this.editForm.gradeId = undefined;
          this.editForm.gradeItemId = undefined;
          this.editForm.classId = undefined;
        } else if (type == 3) {
          this.dialogData.subGradeList = [];
          this.dialogData.classList = [];
          this.editForm.gradeItemId = undefined;
          this.editForm.classId = undefined;
        } else if (type == 4) {
          this.dialogData.classList = [];
          this.editForm.classId = undefined;
        } else if (type == 7) {
          this.dialogData.itemList = [];
          this.editForm.accessItemId = undefined;
        }
        this.dialogSelectList(type, value);
      },
      // 编辑弹窗
      editInfo(row) {
        this.editForm = Object.assign({}, row);
        this.dialogSelectList(1);
        this.dialogSelectList(6);
        this.dialogSelectList(2, row.branchId);
        this.dialogSelectList(3, row.gradeId);
        this.dialogSelectList(4, row.gradeItemId);
        this.dialogSelectList(7, row.accessProjectId);
        this.showEdit = true;
      },
      // 保存评测记录
      saveRecord() {
        this.$refs['editForm'].validate((valid) => {
          if (valid) {
            const loading = this.$loading({ lock: true });
            let formData = new FormData();
            for (let key in this.editForm) {
              if (this.editForm[key] !== null && this.editForm[key] !== undefined) {
                formData.append(key, this.editForm[key]);
              }
            }
            saveAccessRecord(formData).then((res) => {
              loading.close();
              if (res.data.resCode == 200) {
                this.showEdit = false;
                this.$message({ type: 'success', message: res.data.resMsg });
                console.log(this.$refs);
                this.$refs.table.reload();
              } else {
                this.$message.error(res.data.resMsg);
              }
            });
          } else {
            return false;
          }
        });
      },
      // 删除
      remove(row) {
        if (!row) {
          // 批量删除
          if (this.choose.length === 0) return this.$message.error('请至少选择一条数据');
          let ids = this.choose.map((d) => d.id);
          this.$confirm('确定要删除选中的数据吗?', '提示', { type: 'warning' })
            .then(() => {
              const loading = this.$loading({ lock: true });
              let formData = new FormData();
              formData.append('ids', ids);
              delAccessRecord(formData)
                .then((res) => {
                  loading.close();
                  if (res.data.resCode == 200) {
                    this.$message({ type: 'success', message: res.data.resMsg });
                    this.$refs.table.reload();
                  } else {
                    this.$message.error(res.data.resMsg);
                  }
                })
                .catch((e) => {
                  loading.close();
                  this.$message.error(e.message);
                });
            })
            .catch(() => 0);
        } else {
          const loading = this.$loading({ lock: true });
          let formData = new FormData();
          formData.append('ids', [row.id]);
          delAccessRecord(formData)
            .then((res) => {
              loading.close();
              if (res.data.resCode == 200) {
                this.$message({ type: 'success', message: res.data.resMsg });
                this.$refs.table.reload();
              } else {
                this.$message.error(res.data.resMsg);
              }
            })
            .catch((e) => {
              loading.close();
              this.$message.error(e.message);
            });
        }
      },
      // 导出数据
      exportInfo() {
        exportAccessRecord(this.table.where).then((res) => {
          let blob = new Blob([res.data], {
            type: 'application/octet-stream',
          });
          let objectUrl = URL.createObjectURL(blob);
          let link = document.createElement('a');
          link.style.display = 'none';
          link.href = objectUrl;
          let filename = window.decodeURI(res.headers['content-disposition'].split('=')[1], 'UTF-8');
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link); // 下载完成移除元素
          window.URL.revokeObjectURL(objectUrl); // 释放掉blob对象
        });
      },
      //重置表单
      resetForm() {
        this.editForm = {
          branchId: undefined,
          gradeId: undefined,
          gradeItemId: undefined,
          classId: undefined,
          accessProjectId: undefined,
          accessItemId: undefined,
          createDay: undefined,
          createUser: '',
          remark: '',
          type: 2,
        };
        this.$refs['editForm'].resetFields();
      },
    },
  };
</script>

<style scoped></style>
